import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'



import { 
    displayModalAddTiquete,
    updateInputs,
    editPasajero
} from '../../actions/tiquetesaereo'

class ModalAddTiquete extends Component {

	handleCloseModal = (e) => {
		const modal = document.getElementById('modalAddTiquete')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalAddTiquete .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalAddTiquete(false, '', ''), 300)
    }
    


	render() {

        const { modalAddTiquete } = this.props

		if (!modalAddTiquete.get('show')) {
			return null
        }
        
        
        const tipo_trayecto = modalAddTiquete.getIn(['data', 'viaje', 'tipo_trayecto'])        


		return(
			<Modal id="modalAddTiquete" show={ true } ZIndex={ 2000 } width={ 820 } >
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.editPasajero(modalAddTiquete.get('index')) }} noValidate>
					<ModalHeader title={ modalAddTiquete.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="check" disabled={ modalAddTiquete.get('btnDisabled') } title="Aceptar" />
					</ModalButtonStrip>
					<ModalBody>
                        <Fragment>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="control-label">Aerolínea/Proveedor</label>
                                        <input className="form-control input-sm" value={ modalAddTiquete.getIn(['data', 'tiquete', 'aerolinea']) ||'' } onChange={ e => this.props.updateInputs(`modalAddTiquete.data.tiquete.aerolinea`, e.target.value) } />
                                    </div>
                                </div>
                            </div>

                            <div className="separator"></div>

                            <div className="row">
                                <div className="col-md-12">
                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                                        <thead>
                                            <tr>
                                                <th className="text-center" colSpan={ tipo_trayecto == 1 ? 6 : 4 }>Trayectos</th>
                                            </tr>
                                            <tr>
                                                <th>Orígen</th>
                                                <th>Fecha salida</th>
                                                <th>Hora salida</th>
                                                <th>Destino</th>
                                                {
                                                    (tipo_trayecto == 1) && (
                                                        <Fragment>
                                                        <th>Fecha regreso</th>
                                                        <th>Hora regreso</th>
                                                        </Fragment>
                                                    )
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                modalAddTiquete.getIn(['data', 'tiquete', 'itinerarios']).map((t,ti) => {

                                                    const fecha_salida = t.get('fecha_salida').split(' ')[0]
                                                    const hora_salida = t.get('fecha_salida').split(' ')[1] 
                                                    const fecha_llegada = t.get('fecha_llegada') ? t.get('fecha_llegada').split(' ')[0] : moment(new Date()).format('DD/MM/YYY')
                                                    const hora_llegada = t.get('fecha_llegada') ?  t.get('fecha_llegada').split(' ')[1] : moment(new Date()).format('hh:mm A') 

                                                    return(
                                                        <tr key={`itep[${ti}]`}>

                                                            <td>{t.get('origen')}</td>

                                                            <td>
                                                                <input className="form-control input-sm" type="date" value={ fecha_salida || '' } onChange={ e => this.props.updateInputs(`modalAddTiquete.data.tiquete.itinerarios.${ti}.fecha_salida`, `${e.target.value} ${hora_salida}`) }/>
                                                            </td>

                                                            <td>
                                                                <input className="form-control input-sm" type="time" value={ hora_salida || '' } onChange={ e => this.props.updateInputs(`modalAddTiquete.data.tiquete.itinerarios.${ti}.fecha_salida`, `${fecha_salida} ${e.target.value}`) } />
                                                            </td>

                                                            <td>{t.get('destino')}</td>

                                                            {
                                                                (tipo_trayecto == 1) && (
                                                                    <Fragment>
                                                                    <td>
                                                                        <input className="form-control input-sm" type="date" value={ fecha_llegada || '' } onChange={ e => this.props.updateInputs(`modalAddTiquete.data.tiquete.itinerarios.${ti}.fecha_llegada`, `${e.target.value} ${hora_llegada}`) }/>
                                                                    </td>
                                                                    <td>
                                                                        <input className="form-control input-sm" type="time" value={ hora_llegada || '' } onChange={ e => this.props.updateInputs(`modalAddTiquete.data.tiquete.itinerarios.${ti}.fecha_llegada`, `${fecha_llegada} ${e.target.value}`) } />
                                                                    </td>
                                                                    </Fragment>
                                                                )
                                                            }

                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>                                                
                                    </table>
                                </div>                            
                            </div>

                            <div className="separator"></div>

                            <div className="row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Número tiquete</label>
                                        <input className="form-control input-sm" value={ modalAddTiquete.getIn(['data', 'tiquete', 'numero_tiquete']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddTiquete.data.tiquete.numero_tiquete`, e.target.value) } />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">
                                            Tiquete
                                        </label>
                                        <label className={`form-control input-sm label-upload-file label-upload-file-enabled`} onClick={ () => this.props.displayModalAddFile(true, 'Adjuntar archivo', 'create')} >
                                            <i className="fa fa-upload"></i> { modalAddTiquete.getIn(['data','tiquete','adjunto']) ? modalAddTiquete.getIn(['data','tiquete','adjunto', 'file']).name : ' Seleccione un archivo...' }
                                        </label>
                                    </div>
                                </div>

                            </div>


                            <div className="row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Fecha de compra</label>
                                        <input className="form-control input-sm" type="date" value={ modalAddTiquete.getIn(['data', 'tiquete', 'fecha_compra']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddTiquete.data.tiquete.fecha_compra`, e.target.value) } />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Valor</label>
                                        <input className="form-control input-sm" value={ modalAddTiquete.getIn(['data', 'tiquete', 'valor_pagado']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddTiquete.data.tiquete.valor_pagado`, e.target.value) } />
                                    </div>
                                </div>                            
                            
                            </div>
                            
                        </Fragment>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
        modalAddTiquete: state.tiquetesaereo.get('modalAddTiquete'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
        displayModalAddTiquete: (show, title, mode) => dispatch(displayModalAddTiquete(show, title, mode)), 
        updateInputs: (path, value) => dispatch(updateInputs(path, value)), 
        editPasajero: (index) => dispatch(editPasajero(index)), 
	}
}




export default connect(mapStateToProps, mapDispatchToProps)(ModalAddTiquete)



// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/ModalAddTiquete.jsx